import { CreateVideoType } from 'constant/videoTypes'
import React from 'react'

export const ProductNotice = (props: any) => {
  const { createVideoType } = props
  return (
    <div className="flex flex-col gap-[10px] min-h-[101px] p-4 bg-[#FFF3F3] rounded-lg w-full mt-6">
      <p className="font-bold ">✅ 영상이나 이미지를 선택 할 때 체크세요!</p>
      <p className="text-left">
        ⏱️{' '}
        <span className="font-bold text-error">
          {createVideoType === CreateVideoType.PRODUCT_LONG ? '상품당' : '상품'}{' '}
          영상은 최대 1분
        </span>
        , 선택하신 <span className="font-bold text-error">순서대로 배치</span>
        되어 영상이 만들어집니다. <br />
        ✂️ 대본 길이와 선택 순서에 따라 영상의 뒤쪽 일부가 잘리거나, 이미지가
        사용되지 않을 수도 있어요.
      </p>
    </div>
  )
}
